import React from 'react';
import { motion } from 'framer-motion';
import { FaUsers } from 'react-icons/fa';
import { MdSpeed, MdSecurity } from 'react-icons/md';

const Features = () => {
  const features = [
    {
      icon: <MdSpeed className="text-5xl" />,
      title: "Inbox pun, odgovori kasne",
      description: "Kupci očekuju odgovor odmah. Ako čekaju duže od 10 minuta, verovatno su već otišli kod konkurencije."
    },
    {
      icon: <MdSecurity className="text-5xl" />,
      title: "Ponavljajuća pitanja troše vreme",
      description: "Dostava? Cena? Gde mi je paket? Vaš tim (ili vi) trošite sate na odgovore koji mogu biti automatizovani."
    },
    {
      icon: <FaUsers className="text-5xl" />,
      title: "Prodaje cure u razgovoru",
      description: "Ljudski um se umara. Chatbot nikada ne zaboravlja da predloži srodan proizvod ili završi prodaju."
    }
  ];

  return (
    <section id="problem" className="py-20 bg-gradient-to-br from-black via-gray-900 to-black border-t border-b border-gray-800">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Inbox nije arhiva, već tvoja najbolja prodavnica.</h2>
          <p className="text-xl text-gray-300">
            Ali trenutno te usporava umesto da ti donosi profit.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="text-center"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <div className="text-blue-400 mb-6 flex justify-center">{feature.icon}</div>
              <h3 className="text-2xl font-semibold mb-4">{feature.title}</h3>
              <p className="text-gray-300 text-lg">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;